import './App.css';

import Router from './Router';
import { LicenseInfo } from '@mui/x-license';
import { ThemeProvider, createTheme } from '@mui/material';
import UserPermissionPage from './components/UserPermissionPage';
import { getProfile, setProfile } from './reducer/profileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setIAAM } from './reducer/iaamSlice';
import { useState } from 'react';

const theme = createTheme({
    typography: {
        fontFamily: [
            'Noto Sans Thai',
        ].join(','),
    },

    components: {
        MuiPopper: {
            styleOverrides: {
                root: {
                    fontFamily: [
                        'Noto Sans Thai',
                    ].join(','),
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "&&.Mui-selected": {
                        backgroundColor: "#cd6c4a",
                        color: "#fff"
                    },
                    "&&.MuiMenuItem-root:hover": {
                        backgroundColor: "#f0dfda",
                        color: "#000"
                    }
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                listbox: {
                    '& .MuiAutocomplete-option.Mui-focused': {  // works
                        backgroundColor: '#f0dfda',
                        color: "#000"
                    },
                    '& .MuiAutocomplete-option[aria-selected="true"]': { // works
                        backgroundColor: '#fff',
                        color: "#000"
                    },
                    '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': { // works
                        backgroundColor: '#fff',
                        color: "#000"
                    }
                },
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "&&.Mui-checked": {
                        color: "#cd6c4a"
                    }
                }
            }
        },
        MuiPickersYear: {
            styleOverrides: {
                yearButton: {
                    "&&.Mui-selected": {
                        backgroundColor: "#cd6c4a",
                        color: "#fff"
                    },
                }
            }
        },
        MuiPickersMonth: {
            styleOverrides: {
                monthButton: {
                    "&&.Mui-selected": {
                        backgroundColor: "#cd6c4a",
                        color: "#fff"
                    },
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    "&&.Mui-checked": {
                        color: "#cd6c4a",
                        "&&+.MuiSwitch-track": {
                            backgroundColor: "#cd6c4a"
                        },
                    },

                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    "&&.Mui-selected": {
                        color: "#fff",
                        backgroundColor: "#cd6c4a"
                    }
                }
            }
        },
    }
});

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);

const iaam = window.iaam;
// let init = false;


const iaam_conf = {
    op_host: process.env.REACT_APP_IAAM_OP_HOST,
    iaamgw_host: process.env.REACT_APP_IAAM_GATEWAY_HOST,
    client_id: process.env.REACT_APP_IAAM_CLIENT_ID,
    post_logout_uri: process.env.REACT_APP_POST_LOGOUT_URL,
    policyEnforcement: {
        aa_host: process.env.REACT_APP_TRB_AA_HOST,
        client_name: process.env.REACT_APP_CLIENT_NAME,
        ip_verify: true
    }
}

function App() {
    const dispatch = useDispatch();
    const profile = useSelector(getProfile);
    const [isPermited, setIsPermited] = useState(true);

    const getApps = async (inum, access_token) => {
        let options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${access_token}`
            }
        }
        const data = await fetch(`${process.env.REACT_APP_IAAM_PROFILE_PAGE}/iaam-api/applications?inum=${inum}&app_type=WEB`, options);
        const json = await data.json()
        let apps = json.filter((item) => { return item.client_name !== process.env.REACT_APP_CLIENT_NAME ? true : false })
        return apps.map((item) => { return { ...item, client_name: item.client_name.split("-").join(" ") } })
    }

    const getDPC = async (prov_code, access_token) => {
        let options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${access_token}`
            }
        }
        const data = await fetch(`${process.env.REACT_APP_MASTER_API_URL}/dpc/get_dpc_with_prov_code?prov_code=${prov_code}`, options);
        const json = await data.json()
        return json
    }


    const IAAMLogin = async () => {

        iaam.initLoginFlow(iaam_conf)
            .then(async (status) => {
                iaam.isLoggedIn(async (error, status) => {
                    if (!status) {
                        iaam.login()
                    }
                    else {
                        let permited = await iaam?.policyEnforcement();
                        // console.log(permited)
                        let profile = await iaam?.getProfile();
                        iaam.getAccessToken(async (err, access_token) => {
                            if (!err) {
                                const apps = await getApps(profile.inum, access_token);
                                const dpcs = await getDPC(profile?.province_code, access_token);
                                profile["health_region_code"] = dpcs.health_region_code;
                                profile["apps"] = apps
                                dispatch(setIAAM(iaam));
                                dispatch(setProfile(profile));
                            }
                            else {
                                iaam.login()
                            }
                        })
                        if (permited?.decision && permited.decision.toLowerCase() !== "permit") {
                            setIsPermited(false)
                        }

                    }
                })
            })

    }

    // if (!init) {
    // initLogin();
    // init = true;
    // }
    if (profile === undefined) {
        IAAMLogin();
    }

    if (profile === undefined) {
        return (
            <></>
        );
    } else {
        if (isPermited && profile.userApproved === "true") {
            return (
                <ThemeProvider theme={theme}>
                    <Router />
                </ThemeProvider>
                // <div className='App'>
                //     <Router />
                // </div>
            );
        } else {
            return (
                <UserPermissionPage />
            )
        }
    }
}

export default App;

